import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AWARD_LIST, AWARD_WOP_LIST, AWARD_CHANGE_STATUS, AWARD_ADDEDIT, AWARD_DELETE } from "../../api/constApi";
import { awardListApi, awardChangeStatusApi, AddEditAwardApi, awardWopListApi, awardDeleteApi } from "../Services/awardService";

export const awardList = createAsyncThunk(AWARD_LIST, async (payload) => {
    const response = await awardListApi(payload);
    return response.data;
});

export const awardChangeStatus = createAsyncThunk(AWARD_CHANGE_STATUS, async (payload) => {
    const response = await awardChangeStatusApi(payload);
    return response.data;
});

export const addEditAward = createAsyncThunk(AWARD_ADDEDIT, async (payload) => {
    const response = await AddEditAwardApi(payload);
    return response.data;
});

export const awardWopList = createAsyncThunk(AWARD_WOP_LIST, async (payload) => {
    const response = await awardWopListApi(payload);
    return response.data;
});

export const awardDelete = createAsyncThunk(AWARD_DELETE, async (payload) => {
    const response = await awardDeleteApi(payload);
    return response.data;
});

export const awardSlice = createSlice({
    name: "award",
    initialState: {
        award: null,
        // districtWop: null,
        token: null,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(awardList.fulfilled, (state, action) => {
            state.award = action?.payload;
        });
        builder.addCase(addEditAward.fulfilled, (state, action) => {
            state.award = action?.payload?.Data;
        });
    }
});

export default awardSlice.reducer;